module.exports = __webpack_public_path__ + "static/media/slider-l4.c3e533ca.webp";